/* eslint-disable no-unused-vars */
import { SaleOffersState } from 'src/core/models'

const offersState: SaleOffersState = {
  allSaleOffers: {
    loading: false,
    data: []
  },
  offerGroups: {
    loading: false,
    data: [],
    creatingLoading: false,
    successCreate: false,
    errorCreate: false
  },
  filterProject: {
    loading: false,
    data: null,
    notFound: false
  },
  createSaleOffer: {
    loading: false,
    success: false
  },
  userSaleOffers: {
    loading: false,
    data: []
  },
  saleOfferDetails: {
    loading: false,
    currenctOfferId: null,
    saleOffer: null
  },
  acceptOffer: {
    loading: false,
    currenctOfferId: null,
    success: false
  },
  rejectOffer: {
    loading: false,
    currenctOfferId: null,
    success: false
  },
  makeCounterOffer: {
    loading: false,
    currenctOfferId: null,
    success: false
  }
}

export { offersState as initialState }
